import util from 'util'
import socketCluster from 'socketcluster-client'
import axios from 'axios'
import { gunzip, gunzip_pako, range } from '@/utils'
import config from '@/Agent/config'
import PlayStore from '@/stores/PlayStore'
import GameStore from '@/stores/GameStore'
import PrePlayStore from '@/stores/PrePlayStore'

//const API_URL = `${config.PROTOCOL}://${config.URL}:${config.PORT}`

const API_URL = `${config.PROTOCOL}://${config.URL}`
let socket = null
let currentManagedGame = {}
let currentManagedGameInfo = {}
let isDatabaseResettingFromLocal = false
let showDatabaseResetLoader = false
const anyTypes = 'liveplay1x, gamemaster, sponsorplay, prizeplay, announce'

let gameSubscriptionChannel = null

const connectOptions = config.connectOptions

//------------------------------------------------------------------------
const debug = obj => {
  return console.log(util.inspect(obj, { depth: null }))
}

//------------------------------------------------------------------------

const channelWatch = async (channel, processor) => {
  channel.killOutput()
  for await (let data of channel) {
    processor(data)
  }
}

const socketReceiver = async (socket, event, func) => {
  for await (let data of socket.receiver(event)) {
    func(data)
  }
}

const gunzip_function = gunzip //gunzip with DecompressionStream, gunzip_pako with pako

let playAccumulator = {}
let playAccumulatorQueue = []
let setAllPlaysRunning = false

const setAllPlays = async data => {
  if (setAllPlaysRunning) {
    playAccumulatorQueue.push(data)
    return Promise.resolve(null)
  }
  setAllPlaysRunning = true
  while (true) {
    if (data.gz && data.gz.data) data = await gunzip_function(data.gz.data)
    if (data.hasOwnProperty('currentPlay'))
      GameStore.setPlayCurrent(data.currentPlay)
    if (data.hasOwnProperty('nextPlay')) GameStore.setPlayNext(data.nextPlay)
    for (let k of ['stack', 'unresolved', 'resolved']) {
      if (!data.hasOwnProperty(k + 'Plays')) continue
      const K = k.substring(0, 1).toUpperCase() + k.substring(1)
      if (!data.id) {
        GameStore['setPlay' + K](data[k + 'Plays']).then(function() {})
      } else {
        if (!playAccumulator[data.id])
          playAccumulator[data.id] = range(0, data.num_pages - 1).map(
            _v => null
          )
        playAccumulator[data.id][data.page] = data[k + 'Plays']
        if (playAccumulator[data.id].indexOf(null) === -1) {
          playAccumulator[data.id] = playAccumulator[data.id].flat()
          const _data = playAccumulator[data.id].splice(0)
          delete playAccumulator[data.id]
          setTimeout(
            () => GameStore['setPlay' + K](_data).then(function() {}),
            50
          )
        }
      }
    }
    if (playAccumulatorQueue.length) {
      data = playAccumulatorQueue.shift()
    } else {
      break
    }
  }
  setAllPlaysRunning = false
  return Promise.resolve(null)

  /*
  GameStore.setPlayCurrent(data.currentPlay)
  .then(() => GameStore.setPlayNext(data.nextPlay))
  .then(() => GameStore.setPlayStack(data.stackPlays))
  .then(() => GameStore.setPlayUnresolved(data.unresolvedPlays))
  .then(() => GameStore.setPlayResolved(data.resolvedPlays))
  */
}

const connect = ikey => {
  return new Promise(resolve => {
    if (socket == null) {
      if (ikey) {
        localStorage.removeItem('socketcluster.authToken')
      } else {
        if (!localStorage.getItem('socketcluster.authToken')) ikey = 'test'
      }
      socket = socketCluster.create(connectOptions)

      socketReceiver(socket, 'client.operator.data', data => {
        /*
        data.operatorId: current operator ID, should be saved and compared with mainOperatorId
                         whenever mainOperatorId is received. if operatorId === mainOperatorId - then current operator is now the main operator and should be processing timers.

        data.mainOperatorId: main operator ID, may or may not be same as operatorId
        data.isFirstOperator - Boolean
        */
        console.log('client.operator.data', data) //tmp
        PrePlayStore.setOperatorData(data)
      })

      socketReceiver(socket, 'client.info', data => {
        GameStore.setInfo(data)
      })

      socketReceiver(socket, 'client.play.all', data => {
        console.log('CLIENT.PLAY.ALL') //tmp
        setAllPlays(data).then(function() {})
      })

      socketReceiver(socket, 'client.play.all.gz', data => {
        console.log('CLIENT.PLAY.ALL') //tmp
        gunzip_function(data.data).then(data =>
          setAllPlays(data).then(function() {})
        )
      })

      socketReceiver(socket, 'client.play.current', data => {
        GameStore.setPlayCurrent(data)
      })

      socketReceiver(socket, 'client.play.next', data => {
        GameStore.setPlayNext(data)
      })

      socketReceiver(socket, 'client.play.stack', data => {
        console.log('CLIENT.PLAY.STACK') //tmp
        GameStore.setPlayStack(data)
      })

      socketReceiver(socket, 'client.play.unresolved', data => {
        GameStore.setPlayUnresolved(data)
      })

      socketReceiver(socket, 'client.play.resolved', data => {
        GameStore.setPlayResolved(data)
      })

      socket
        .listener('connect')
        .once()
        .then(() => {
          if (socket.authState !== socket.AUTHENTICATED) {
            socket.transmit('auth', ikey ? { ikey: ikey } : 1)
            socketReceiver(socket, 'user.login.failed', () => resolve(false))
          }
        })

      socketReceiver(socket, 'user.login.respond', () => {
        sendClientAutomationCredentials()
        PrePlayStore.syncClock()
        return resolve(socket)
      })
    } else {
      return resolve(socket)
    }
  })
}

const sendClientAutomationCredentials = async () => {
  for await (let request of socket.procedure('client.automation.credentials')) {
    if (!request.sent)
      request.end(
        JSON.stringify({
          headless: GameStore.headless,
          executionType: GameStore.executionType,
          isViewRecordedEvent: GameStore.isViewRecordedEvent,
        })
      )
  }
}

export async function send(channel, data, opts) {
  if (channel === 'games.update') {
    return Promise.resolve({ item: data ? data.value : null })
  }
  if (!opts) opts = {}
  await connect()
  return new Promise((resolve, reject) => {
    console.log(`[Server Send : ${channel}]`)

    const _data = {
      event: channel,
      data: data,
    }
    if (opts.transmit) {
      socket.transmit(opts.trigger || 'i', _data)
      console.log(['socket.transmit', _data]) //tmp to delete
      return resolve(null)
    }
    socket
      .invoke(opts.trigger || 'i', _data)
      .then(response => {
        //socket.emit(channel, data, (response, err) => {
        console.log(['socket.invoke', _data]) //tmp to delete
        if (response && response.error) {
          PlayStore.showErrorPage(response.error)
        }
        if (response) {
          if (response.success) {
            return resolve(response.response)
          } else {
            return reject(response)
          }
        }
      })
      .catch(err => {
        console.error(`[Socket Invoke Error] channel: ${channel}`, err)
        reject(err)
      })
  })
}

export const broadcastPlay = type => {
  return send('games.changeplay', type, { transmit: true })
}

export const broadcastLockout = val => {
  return send('games.lockplay', val, { transmit: true })
}

export const endPlay = val => {
  return send('games.endplay', val, { transmit: true })
}

export const changeNextPlay = val => {
  return send('games.changenextplay', val, { transmit: true })
}

export const showResult = val => {
  return send('games.result', val)
}

export const broadcastResolvePending = val => {
  return send('games.resolve', val, { transmit: true })
}

export const announcement = val => {
  return send('games.announcement', val, { transmit: true })
}

export const typeList = () => {
  return send('games.typelist', {})
}

export const activeGame = args => {
  return send('games.active', args)
}

export const gamesInfo = args => {
  return send('games.info', args)
}

export const authenticate = args => {
  return send('authentication', args)
}

export const gamesCreate = args => {
  let testGame
  return send('games.create', args)
    .then(response => {
      console.log('initially created game', response.item.id)
      return send('games.pending', { progress: 'Pending' })
    })
    .then(games => {
      testGame = games[0]
      console.log(`pending games ${games.map(g => g.id)}`)
      return send('games.info', [testGame.id])
    })
    .then(gamesInfo => {
      testGame.playStack = gamesInfo[0].playStack
      return send('games.update', { entityType: 'Game', value: testGame })
    })
    .then(updateResponse => {
      return (testGame = updateResponse.item)
    })
    .catch(err => {
      console.log(`error in setting up the database ${err}`)
    })
}

export const gamesPending = args => {
  return send('games.pending', args)
}

export const gamesUpdate = args => {
  return send('games.update', args)
}

export const readBrandPackages = () => {
  return send('host.read.brand.packages')
}

export const readGameMasters = () => {
  return send('host.read.game.masters')
}

export const readCelebrities = () => {
  return send('host.read.celebrities')
}

export const getBrandappBrandIds = args => {
  //args.sportTypeCode
  //args.location
  return send('app.read.brandapp.brand.ids', args)
}

export const getBrandapp = args => {
  //args.gameId
  return send('app.read.brandapp', args)
}

export const getBrandappConfig = () => {
  return send('app.read.brandapp.config', null)
}

const transmitPublish = args => {
  send(args.event, args.data, {
    transmit: true,
    trigger: 'hc',
  }).then(function() {})
}

export const gamesUpdatePreset = args => {
  transmitPublish({
    event: 'games.removeplayfromstack',
    data: { playId: args.playId },
  })
}

export const removePlayFromStack = playId => {
  transmitPublish({
    event: 'games.removeplayfromstack',
    data: { playId: playId },
  })
}

export const gamesRead = args => {
  return send('games.read', args)
}

export const gamesGoPlay = playToGo => {
  transmitPublish({
    event: 'games.goplay',
    data: { play: playToGo },
  })
}

export const gamesStartPlay = playId => {
  transmitPublish({
    event: 'games.startplay',
    data: { playId: playId },
  })
}

export const gamesLockPlay = playId => {
  transmitPublish({
    event: 'games.lockplay',
    data: { playId: playId },
  })
}

export const gamesEndPlay = args => {
  transmitPublish({
    event: 'games.endplay',
    data: { playId: args.playId, result: args.result },
  })
}

export const gamesConfirmPlay = playId => {
  transmitPublish({
    event: 'games.confirmplay',
    data: { playId: playId },
  })
}

export const gamesEndGame = () => {
  transmitPublish({ event: 'games.endgame' })
}

export const manageGame = async game => {
  await connect()
  return new Promise(resolve => {
    currentManagedGame = game
    if (!socket.isSubscribed(game.id + '.host')) {
      currentManagedGame['hostGameChannel'] = socket.subscribe(
        game.id + '.host'
      )
      establishHostWatchers()
    }
    resolve(currentManagedGame['hostGameChannel'])
  })
}

const establishHostWatchers = () => {
  //hostGameChannel.watch(data => {
  channelWatch(currentManagedGame['hostGameChannel'], data => {
    console.log('host==>>>', data.data)
    switch (data.event) {
      case 'plays.stackupdate':
        console.log('PLAYS.STACKUPDATE', data.data)
        PlayStore.updatePlayStack({
          playStack: data.data.playStack,
          plays: data.data.plays,
        })
        break
      case 'games.update':
        const updatedGame = Object.assign(currentManagedGameInfo, data.data)
        console.log('GAMES.UPDATE', updatedGame)
        //PlayStore.updateGameX1(updatedGame)
        PlayStore.setGame(data.data)
        break
      case 'games.startplay':
        console.log('GAMES.STARTPLAY', PlayStore.game.id, data)
        //PlayStore.updateGame()
        PlayStore.gamesStartPlayNull(data.data)
        break
      case 'games.endplay':
        console.log('GAMES.ENDPLAY', data.data)
        PlayStore.gamesEndPlayResult(data.data)
        break
      case 'plays.update':
        console.log('PLAYS.UPDATE', data.data)
        PlayStore.playUpdate(data.data)
        break
      case 'games.endgame':
        console.log('GAMES.ENDGAME')
        PlayStore.gamesEndGameWatch()
        break
      case 'database.reset':
        console.log('DATABASE.RESET', data.data)
        if (!isDatabaseResettingFromLocal) {
          PlayStore.setShowDatabaseResetLoader(true)
        }
        break
      default:
        if (
          [
            'games.prepickstart',
            'games.ready',
            'games.start',
            'games.endplay',
            'games.addplaytostack',
            'games.removeplayfromstack',
            'games.goplay',
            'games.lockplay',
            'games.confirmplay',
            'games.moveplaybefore',
          ].indexOf(data.event) < 0
        ) {
          // missing implementation
          console.log('unimplemented event', data)
        }
    }
  })

  console.log('SUBSCRIBED', currentManagedGame['hostGameChannel'])
}

let syncGuid = ''
export const sendBeaconLastSessionTime = args => {
  navigator.sendBeacon(
    `${API_URL}/analytics/last_session_time`,
    JSON.stringify(args)
  )
}

export const connectSC = ikey => {
  return connect(ikey)
}

export const setHeadless = args => {
  transmitPublish({
    event: 'host.automation.headless',
    data: { isHeadless: args, gameId: GameStore.gameId },
  })
}

export const addThePlay = play => {
  transmitPublish({ event: 'host.play.add', data: play })
}

export const updateTeamScore = (team_idx, score) => {
  transmitPublish({ event: 'host.update.team.score', data: [team_idx, score] })
}

export const updateTeamPossession = (team_idx, possession) => {
  transmitPublish({
    event: 'host.update.team.possession',
    data: [team_idx, possession],
  })
}

export const updatePlay = play => {
  transmitPublish({ event: 'host.play.update', data: play })
}

export const removePlay = params => {
  transmitPublish({ event: 'host.play.remove', data: params })
}

export const removePlayBulk = params => {
  transmitPublish({ event: 'host.play.remove.bulk', data: params })
}

export const gameStart = args => {
  transmitPublish({ event: 'host.game.start', data: args })
}

export const gameResume = args => {
  transmitPublish({ event: 'host.game.resume', data: args })
}

export const gamePause = args => {
  transmitPublish({ event: 'host.game.pause', data: args })
}

export const gameEnd = gameId => {
  transmitPublish({ event: 'host.game.end', data: gameId })
}

export const goPlay = play => {
  transmitPublish({ event: 'host.play.go', data: play })
}

export const resolvePlay = args => {
  transmitPublish({ event: 'host.play.resolve', data: args })
}

export const endCurrentPlay = args => {
  transmitPublish({ event: 'host.play.endplay', data: args })
}

export const resetDatabase = args => {
  transmitPublish({ event: 'host.game.reset', data: args })
}

export const resolvePrePick = args => {
  transmitPublish({ event: 'host.prepick.resolve', data: args })
}

export const updateParticipantForStack = args => {
  transmitPublish({
    event: 'host.play.stack.update',
    data: args,
  })
}

export const resetRecording = args => {
  transmitPublish({ event: 'host.recording.reset', data: args })
}

export const restartAutomation = args => {
  transmitPublish({
    event: 'host.automation.restart',
    data: args,
  })
}

export const automationPaused = args => {
  transmitPublish({
    event: 'host.automation.paused',
    data: args,
  })
}

export const automationResumed = args => {
  transmitPublish({
    event: 'host.automation.resumed',
    data: args,
  })
}

export const movePlay = args => {
  transmitPublish({
    event: 'host.play.move',
    data: args,
  })
}

// export const importPlaystack = args => {
//   connect()
//   gameSubscriptionChannel.transmitPublish({
//     event: 'host.import.playstack',
//     data: args
//   })
// }

export const importPlaystack = args => {
  //console.log("host.import.playstack", args.playsToImport.values)
  return send('host.import.playstack', args)
}

export const importQA = args => {
  /*
  args:
  {
    gameId,
    plays, //plays is (possibly stringified?) array of plays in exactly the same format as addThePlay
  }
  Returns:
  Number of added plays, similar to GameServer.importPlaystack
  {'playCount' : number}
  */
  const token = localStorage.getItem('socketcluster.authToken')
  if (!token) throw new Error('unauthorized')

  return axios({
    method: 'POST',
    url: `${API_URL}/game/import_qa`,
    data: args,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
}

export const readGameEvents = args => {
  return send('host.read.gameevents', args)
}

export const getGamePlaysByGameId = async args => {
  let res = await send('host.read.game.by.id', args)
  if (res.gz && res.gz.data) res = await gunzip_function(res.gz.data)
  return Promise.resolve(Array.isArray(res) ? res : [])
}

export const updateGmAssetQuantity = (gmAssetId, newQuantity) => {
  //transmit
  send(
    'host.update.gm.asset.quantity',
    {
      id: gmAssetId,
      quantity: newQuantity,
    },
    { transmit: true }
  )
}

export const insertRecordedAutomation = args => {
  //transmit
  send('host.insert.recorded.automation', args, { transmit: true })
}

export const getBrands = () => {
  return send('user.read.brands', null)
}

export const syncRequest = args => {
  syncGuid = args.syncGuid
  transmitPublish({ event: 'host.sync.request', data: args })
}

export const readImportFilterArgs = args => {
  return axios({
    method: 'GET',
    url: `${API_URL}/game/read_import_filter_args`,
    params: args,
    headers: {
      Authorization:
        'Bearer ' + localStorage.getItem('socketcluster.authToken'),
      'Content-Type': 'application/json',
    },
  })
}

export const readQAFile = fileId => {
  return axios({
    method: 'GET',
    url: `${API_URL}/game/read_qa_file`,
    params: { fileId: fileId },
    headers: {
      Authorization:
        'Bearer ' + localStorage.getItem('socketcluster.authToken'),
    },
  })
}

export const readQAFileList = sportType => {
  return axios({
    method: 'GET',
    params: { sportType: sportType }, //sport type code
    url: `${API_URL}/game/read_qa_file_list`,
    headers: {
      Authorization:
        'Bearer ' + localStorage.getItem('socketcluster.authToken'),
      'Content-Type': 'application/json',
    },
  })
}

export const subscribeToGame = (args, gameEvents) => {
  connect().then(function() {
    const gameChannelName = `${args.event}.host`

    if (gameEvents && gameEvents.length > 0) {
      gameEvents.forEach(gEvent => {
        if (args.event !== gEvent) {
          const existingSubscription = socket.subscriptions(true)
          const gameToUnsubs = `${gEvent}.host`
          if (existingSubscription.indexOf(gameToUnsubs) >= 0) {
            socket.unsubscribe(gameToUnsubs)
          }
        }
      })
    }

    const socketSubscriptions = socket.subscriptions(true)

    if (socketSubscriptions.indexOf(gameChannelName) >= 0) {
      gameSubscriptionChannel = socket.channel(gameChannelName)
    } else {
      gameSubscriptionChannel = socket.subscribe(gameChannelName)
    }

    //gameSubscriptionChannel.watch(data => {
    channelWatch(gameSubscriptionChannel, data => {
      //data.data = data.data.reverse()
      console.log('data==>>>', data.event, data.data)
      switch (data.event) {
        case 'host.main.operator.id':
          /*
          data.data.mainOperatorId - should be compared with current operatorId
            If operatorId === mainOperatorId - then current operator is now the main operator and should be processing timers.
          */
          console.log('mainOperator: ' + data.data) //tmp
          PrePlayStore.setMainOperatorId(data.data)
          break
        case 'host.gm.assets':
          // process GM Video & msg assets here
          // this will be pushed on initial load and if updated in the platform
          GameStore.setGameAssets(data.data)
          console.log(data.data) //tmp
          break
        case 'host.sporttype.info':
          GameStore.setSportTypeInfo(data.data)
          break
        case 'host.info.respond':
          GameStore.setInfo(data.data)
          break
        case 'host.play.all':
          setAllPlays(data.data).then(function() {})
          break
        case 'host.play.all.gz':
          gunzip_function(data.data.data).then(data =>
            setAllPlays(data).then(function() {})
          )
          break
        case 'host.play.current':
          GameStore.setPlayCurrent(data.data)
          break
        case 'host.play.next':
          GameStore.setPlayNext(data.data)
          break
        case 'host.play.stack':
        case 'host.play.stack':
          console.log('HOST.PLAY.STACK', data.data)
          GameStore.setPlayStack(data.data)
          break
        case 'host.play.unresolved':
          GameStore.setPlayUnresolved(data.data)
          break
        case 'host.play.resolved':
          GameStore.setPlayResolved(data.data)
          break
        case 'host.play.stats':
          if (data.data.plays) GameStore.addPlayStats(data.data.plays)
          if (data.data.brandapp) GameStore.setBrandappStats(data.data.brandapp)
          break
        case 'host.play.stats.all':
          if (data.data.plays) GameStore.addPlayStats(data.data.plays, true)
          if (data.data.brandapp) GameStore.setBrandappStats(data.data.brandapp)
          break
        case 'host.prepick.resolved':
          GameStore.setPrePickResolved(data.data)
          break
        case 'host.prepicks.update':
          GameStore.setPrepicks(data.data)
          break
        case 'host.game.update':
          if (data.hasReset) {
            GameStore.setHasReset(data.hasReset)
          }
          GameStore.setInfo(data.data)
          break
        case 'host.game.resume.respond':
          GameStore.gameResumeRespond(data.data)
          break
        case 'host.play.remove.respond':
          GameStore.setRemovedPlay(data.data)
          break
        case 'host.play.update.respond':
          GameStore.setUpdatedPlay(data.data)
          break
        case 'host.automation.set.sequences':
          GameStore.setSequences(data.data)
          break
        case 'host.sync.response':
          if (data.data.syncGuid && data.data.syncGuid != syncGuid) {
            syncGuid = ''
            GameStore.syncResponse(data.data)
          } else if ('INPUT_CHANGE,DD_CHANGE'.includes(data.data.processName)) {
            syncGuid = ''
            GameStore.syncResponse(data.data)
          }
          break
        case 'host.game.pause.respond':
          GameStore.gamePauseRespond(data.data)
          break
        case 'host.game.end.respond':
          GameStore.setRecordEnded(true)
          GameStore.setSessionMode(0)
          break
        case 'host.game.autostart':
          //
          break
      }
    })
  })
}



// WEBPACK FOOTER //
// src/Agent/GameServer.js